import { useState } from "react";

import Tag from "ui-components/Tag";
import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";
import InputField from "ui-components/Input-Field";

import { useUpdateColumnName, useGetFileColumnRenameReversers } from "./store";
interface Props {
  fileIds: string[];
  column: string;
}

const ColumnName = ({ fileIds, column }: Props) => {
  const updateColumnName = useUpdateColumnName(fileIds, column);
  const nameReversers = useGetFileColumnRenameReversers(fileIds);

  const [open, setOpen] = useState(false);
  const [newName, setNewName] = useState<string>();
  const close = () => {
    setOpen(false);
    setNewName(null);
  };
  const saveAndClose = () => {
    updateColumnName(newName || null);
    setOpen(false);
  };
  return (
    <div className="p-1">
      <p>{column}</p>
      <div className="flex flex-wrap">
        {fileIds
          .filter(
            (f) =>
              !!nameReversers[f][column] && nameReversers[f][column] !== column
          )
          .map((f) => (
            <Tag key={f}>
              {nameReversers[f][column]} in {f}
            </Tag>
          ))}
      </div>
      <p>
        <span
          className="text-sm cursor-pointer text-primary-main"
          onClick={() => setOpen(true)}
        >
          UPDATE COLUMN NAME
        </span>
      </p>
      <Modal
        id={`rename-${column}`}
        show={open}
        title={`Change Name for ${column}`}
        handleClose={close}
      >
        <InputField<string> type="text" value={newName} onChange={setNewName} />
        <Divider />
        <p className="text-right">
          <Button color="gray" onClick={close}>
            Close
          </Button>
          <Button color="gray" onClick={saveAndClose}>
            Save
          </Button>
        </p>
      </Modal>
    </div>
  );
};

export default ColumnName;
